const Layout = () => import('../pages/layout')
const staticRoutes = [{
		path: '/',
		redirect: '/login',
	},
	// 错误页面
	{
		path: '/error',
		component: Layout,
		children: [{
			path: '401',
			component: () => import( /* webpackChunkName: 'error' */ '../pages/error/401')
		}]
	},
	// 登录
	{
		path: '/login',
		component: () => import('../pages/login')
	},
	// 系统数据,echart图标展示等
	{
		path: '/home',
		component: Layout,
		children: [{
			path: '',
			meta: {label:'首页'},
			component: () => import( /* webpackChunkName: 'home' */ '../pages/home')
		}]
	},
	// 管理组
	{
		path: '/manageGroup',
		component: Layout,
		children: [{
			path: '',
			meta: {label:'管理组'},
			component: () => import( /* webpackChunkName: 'manageGroup' */ '../pages/manageGroup')
		}]
	},
	// 管理员列表
	{
		path: '/manageList',
		component: Layout,
		children: [{
			path: '',
			meta: {label:'管理员'},
			component: () => import( /* webpackChunkName: 'manageList' */ '../pages/manageList')
		}]
	},
	// 方法权限组
	{
		path: '/authList',
		component: Layout,
		children: [{
			path: '',
			meta: {label:'方法权限'},
			component: () => import( /* webpackChunkName: 'authList' */ '../pages/authList')
		}]
	},
	// 新闻动态
	{
		path: '/news',
		component: Layout,
		children: [{
				path: '',
				meta: {label:'新闻动态'},
				component: () => import( /* webpackChunkName: 'news' */ '../pages/news')
			},
			{
				path: 'add',
				name: '/news',
				meta: {label:'添加新闻'},
				component: () => import( /* webpackChunkName:'news' */ '../pages/news/addNews')
			}
		]
	},
	// 静态html生成
	{
		path: '/createHtml',
		component: Layout,
		children: [{
				path: '',
				meta: {label:'html生成'},
				component: () => import( /* webpackChunkName: 'createHtml' */ '../pages/createHtml')
			}
		]
	},
	// 论坛留言板
	{
		path: '/BBSModule',
		component: Layout,
		children: [{
				path: '',
				meta: {label:'论坛留言'},
				component: () => import( /* webpackChunkName: 'BBSModule' */ '../pages/BBSModule')
			},
			{
				path: 'messageList',
				name:'/BBSModule',
				meta: {label:'留言列表'},
				component: () => import( /* webpackChunkName: 'BBSModule' */ '../pages/BBSModule/messageList')
			},
			{
				path: 'bbsAttr',
				name:'/BBSModule',
				meta: {label:'字段管理'},
				component: () => import( /* webpackChunkName: 'BBSModule' */ '../pages/BBSModule/bbsAttr')
			}
		]
	},
	// 评论
	{
		path: '/comment',
		component: Layout,
		children: [{
				path: '',
				meta: {label:'评论管理'},
				component: () => import( /* webpackChunkName: 'comment' */ '../pages/comment')
			}
		]
	},
	// 操作日志
	{
		path: '/logRecord',
		component: Layout,
		children: [{
			path: '',
			meta:{label:'操作日志'},
			component: () => import( /* webpackChunkName: 'logRecord' */ '../pages/logRecord')
		}]
	},
	//内容
	{
		path: '/document',
		component: Layout,
		children: [{
			path: '',
			meta:{label:'内容管理'},
			component: () => import( /* webpackChunkName: 'document' */ '../pages/document')
		},
		{
			path: 'addDocument',
			name:'/document',
			meta: {label:'发布内容'},
			component: () => import( /* webpackChunkName: 'document' */ '../pages/document/addDocument')
		},
		{
			path: 'statistics',
			name:'/document',
			meta: {label:'数据统计'},
			component: () => import( /* webpackChunkName: 'document' */ '../pages/document/statistics')
		}
		]
	},
	//内容分类管理
	{
		path: '/documentType',
		component: Layout,
		children: [{
			path: '',
			meta: {label:'分类管理'},
			component: () => import( /* webpackChunkName: 'documentType' */ '../pages/documentType')
		},{
			path: 'addType',
			name:'/documentType',
			meta: {label:'添加分类'},
			component: () => import( /* webpackChunkName: 'documentType' */ '../pages/documentType/addType')
		},{
			path: 'addSinglePage',
			name:'/documentType',
			meta: {label:'添加单页'},
			component: () => import( /* webpackChunkName: 'documentType' */ '../pages/documentType/addSinglePage')
		},{
			path: 'addLink',
			name:'/documentType',
			meta: {label:'添加链接'},
			component: () => import( /* webpackChunkName: 'documentType' */ '../pages/documentType/addLink')
		},{
			path: 'copyInfo',
			name:'/documentType',
			meta: {label:'同步内容'},
			component: () => import( /* webpackChunkName: 'documentType' */ '../pages/documentType/copyInfo')
		},{
			path: 'turnInfo',
			name:'/documentType',
			meta: {label:'转移内容'},
			component: () => import( /* webpackChunkName: 'documentType' */ '../pages/documentType/turnInfo')
		}]
	},
	//内容模型管理
	{
		path: '/documentModel',
		component: Layout,
		children: [{
			path: '',
			meta: {label:'模型管理'},
			component: () => import( /* webpackChunkName: 'documentModel' */ '../pages/documentModel')
		},
		{
			path: 'modelAttr',
			name:'/documentModel',
			meta: {label:'模型字段'},
			component: () => import( /* webpackChunkName: 'documentModel' */ '../pages/documentModel/modelAttr')
		},
		{
			path: 'addModel',
			name:'/documentModel',
			meta: {label:'添加模型'},
			component: () => import( /* webpackChunkName: 'documentModel' */ '../pages/documentModel/addModel')
		}]
	},
	//内容推荐位管理
	{
		path: '/documentLabel',
		component: Layout,
		children: [{
			path: '',
			meta: {label:'推荐管理'},
			component: () => import( /* webpackChunkName: 'documentLabel' */ '../pages/documentLabel')
		}]
	},
	//广告位
	{
		path: '/advertType',
		component: Layout,
		children: [{
			path: '',
			meta: {label:'广告管理'},
			component: () => import( /* webpackChunkName: 'advertType' */ '../pages/advertType')
		},{
			path: '/advertList',
			name:'/advertType',
			meta: {label:'广告列表'},
			component: () => import( /* webpackChunkName: 'advertType' */ '../pages/advertType/advertList')
		}]
	},
	//在线客服管理
	{
		path: '/kefu',
		component: Layout,
		children: [{
			path: '',
			meta: {label:'在线客服'},
			component: () => import( /* webpackChunkName: 'kefu' */ '../pages/kefu')
		}]
	},
	//友情链接管理
	{
		path: '/friendLink',
		component: Layout,
		children: [{
			path: '',
			meta: {label:'友链管理'},
			component: () => import( /* webpackChunkName: 'friendLink' */ '../pages/friendLink')
		}]
	},
	//SEO优化
	{
		path: '/keylink',
		component: Layout,
		children: [{
			path: '',
			meta: {label:'SEO优化'},
			component: () => import( /* webpackChunkName: 'keylink' */ '../pages/keylink')
		},{
			path: 'keyword',
			name:'keylink',
			meta: {label:'优化词'},
			component: () => import( /* webpackChunkName: 'keylink' */ '../pages/keylink/keyword')
		},{
			path: 'addKeyword',
			name:'keylink',
			meta: {label:'添加优化词'},
			component: () => import( /* webpackChunkName: 'keylink' */ '../pages/keylink/addKeyword')
		},{
			path: 'addKeylinkType',
			name:'keylink',
			meta: {label:'添加分组'},
			component: () => import( /* webpackChunkName: 'keylink' */ '../pages/keylink/addKeylinkType')
		}]
	},
	// 模板管理
	{
		path: '/templateManage',
		component: Layout,
		children: [{
			path: '',
			meta: {label:'模板管理'},
			component: () => import( /* webpackChunkName: 'templateManage' */ '../pages/templateManage')
		},{
			path: 'fileEdit',
			name:'templateManage',
			meta: {label:'文件修改'},
			component: () => import( /* webpackChunkName: 'templateManage' */ '../pages/templateManage/fileEdit')
		},{
			path: 'fileCopy',
			name:'templateManage',
			meta: {label:'模板复制'},
			component: () => import( /* webpackChunkName: 'templateManage' */ '../pages/templateManage/fileCopy')
		}]
	},
	// 上传文件管理
	{
		path: '/fileManage',
		component: Layout,
		children: [{
			path: '',
			meta: {label:'上传管理'},
			component: () => import( /* webpackChunkName: 'fileManage' */ '../pages/fileManage')
		}]
	},
	// 网站主题
	{
		path: '/webThemes',
		component: Layout,
		children: [{
			path: '',
			meta: {label:'网站主题'},
			component: () => import( /* webpackChunkName: 'webThemes' */ '../pages/webThemes')
		}]
	},
	// 系统设置
	{
		path: '/setting',
		component: Layout,
		children: [{
			path: '',
			meta: {label:'系统设置'},
			component: () => import( /* webpackChunkName: 'setting' */ '../pages/setting')
		}]
	},
	// 多语言
	{
		path: '/languageManage',
		component: Layout,
		children: [{
			path: '',
			meta: {label:'多语言设置'},
			component: () => import( /* webpackChunkName: 'languageManage' */ '../pages/languageManage')
		}]
	},
	
]
export default staticRoutes
